// extracted by mini-css-extract-plugin
export var steps = "style-module--steps--3YSfS";
export var steps_head = "style-module--steps_head--1kK-Z";
export var steps_main = "style-module--steps_main--EkAgG";
export var steps_bot = "style-module--steps_bot--1XIdO";
export var steps_bot_btn = "style-module--steps_bot_btn--3RUIF";
export var steps_suptitle = "style-module--steps_suptitle--n3o9U";
export var steps_progress = "style-module--steps_progress--SuPGl";